module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAjCAMAAABB9MFTAAAASFBMVEUAAABiYmJgYGBmZmZmZmZmZmZlZWVlZWVmZmZlZWVmZmZmZmZmZmZlZWVmZmZlZWVmZmZlZWVlZWVmZmZmZmZlZWVmZmZmZmbuKCgtAAAAF3RSTlMAFAvq4n1n32SDeOcRbfSx0rWfk1VEHgwCLiEAAABrSURBVCjPnc5JDsAgDAPAdIFA2brn/z+tekwCqoqPI9kyXIeNIFIy2lGYn2iWOJhf6CqITfze9C1U9Y7z3T8xAc9diFZOo0MKnpNFmszAae6kVKP++bBUKKqiIL0VnSJY3iIn2HIwguDcFT1NFQbmpmDnfAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/swiperToRightIcon.png
// module id = 8HV3
// module chunks = 2